import {gql} from "@apollo/client";

export const ANALYZE_CHANGES = gql`
	query AnalyzeChanges(
		$idFilter: [String!]
	) {
		analyzeChanges(
			idFilter: $idFilter
		) {
			stages
			modules {
				id
				name
			}
			phraseItems {
				id
				phrase
			}
			translationItems {
				id
				languageCode
				moduleId
				phraseId
				translation
				approvalDate
			}
		}
	}
`;

export const GET_MODULES = gql`
	query Query(
		$stage: String
		$first: Int
		$after: String
		$where: ModuleFilterInput
		$order: [ModuleSortInput!]
	) {
		modules(
			stage: $stage
			first: $first
			after: $after
			where: $where
			order: $order
		) {
			pageInfo {
				hasNextPage
				hasPreviousPage
				startCursor
				endCursor
			}
			nodes {
				id
				name
				creationDateTime
				lastModifiedDateTime
				lastModifiedBy
			}
		}
	}
`;
export const GET_MODULE = gql`
	query Query(
		$stage: String
		$id: UUID!
	)  {
		modules(
			stage: $stage
			where: {
				id: {
					eq: $id
				}
			}
		) {
			nodes {
				id
				name
				creationDateTime
				lastModifiedDateTime
				lastModifiedBy
			}
		}
	}
`;

export const PUT_MODULE = gql`
	mutation Mutation(
		$stage: String
		$module: ModuleInput!
	) {
		putModule(
			stage: $stage
			module: $module
		) {
			success
			errors {
				message
				code
			}
		}
	}
`;

export const GET_PHRASE_ITEMS = gql`
query Query($stage: String, $first: Int, $after: String, $where: PhraseItemFilterInput, $order: [PhraseItemSortInput!]) {
    phraseItems(
        stage: $stage
        first: $first
        after: $after
        where: $where
        order: $order
    ) {
        pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
            __typename
        }
        nodes {
            id
            phrase
            creationDateTime
            lastModifiedDateTime
            lastModifiedBy
            __typename
        }
        __typename
    }
}
`;
export const GET_PHRASE_ITEM = gql`
	query Query(
		$stage: String
		$id: UUID!
	)  {
		phraseItems(
			stage: $stage
			where: {
				id: {
					eq: $id
				}
			}
		) {
			nodes {
				id
				phrase
				locationUrl
				creationDateTime
				lastModifiedDateTime
				lastModifiedBy
			}
		}
	}
`;
export const PUT_PHRASE_ITEM = gql`
	mutation Mutation(
		$stage: String
		$phrase: PhraseItemInput!
	) {
		putPhraseItem(
			stage: $stage
			phrase: $phrase
		) {
			success
			errors {
				message
				code
			}
		}
	}
`;

export const DELETE_PHRASES_ITEM_AND_INHERITED = gql`
	mutation Mutation(
		$stage: String
		$phraseIds: [UUID!]!
	) {
		deletePhrasesItemAndInherited(
			stage: $stage
			phraseIds: $phraseIds
		) {
			deleteCount
			errors {
				message
				code
			}
		}
	}
`;
export const GET_TRANSLATION_ITEMS = gql`
query Query($stage: String, $first: Int, $after: String, $where: TranslationItemFilterInput, $order: [TranslationItemSortInput!]) {
    translationItems(
        stage: $stage
        first: $first
        after: $after
        where: $where
        order: $order
    ) {
        pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
            __typename
        }
        nodes {
            id
            moduleId
            phraseId
            languageCode
            translation
            approvalDate
			locationUrl
            creationDateTime
            lastModifiedDateTime
            lastModifiedBy
            __typename
        }
        __typename
    }
}
`;

export const GET_TRANSLATION_ITEM = gql`
	query Query(
		$stage: String
		$id: UUID!
	)  {
		translationItems(
			stage: $stage
			where: {
				id: {
					eq: $id
				}
			}
		) {
			nodes {
				id
				moduleId
				phraseId
				languageCode
				translation
				approvalDate
				locationUrl
				creationDateTime
				lastModifiedDateTime
				lastModifiedBy
			}
		}
	}
`;

export const EXISTS_MODULE = gql`
	query Query(
		$stage: String
		$name: String
	) {
		modules(
			stage: $stage
			first: 1
			where:{ name:{
				eq:$name
				}
			}
		) {
			nodes {
				id
			}
		}
	}
`;

export const EXISTS_MODULE_BY_ID = gql`
	query Query(
		$stage: String
		$id: UUID
	) {
		modules(
			stage: $stage
			first: 1
			where:{ id:{
				eq:$id
				}
			}
		) {
			nodes {
				id
			}
		}
	}
`;

export const EXISTS_PHRASE = gql`
	query Query(
		$stage: String
		$phrase: String
	) {
		phraseItems(
			stage: $stage
			first: 1
			where:{ phrase: {
				eq:$phrase
				}
			 }
		) {
			nodes {
				id
			}
		}
	}
`;

export const EXISTS_PHRASE_BY_ID = gql`
	query Query(
		$stage: String
		$id: UUID
	) {
		phraseItems(
			stage: $stage
			first: 1
			where:{ id: {
				eq:$id
				}
			 }
		) {
			nodes {
				id
			}
		}
	}
`;

export const EXISTS_TRANSLATION_ITEM = gql`
	query Query(
		$stage: String
		$moduleId: UUID!
		$phraseId: UUID!
		$languageCode :String!
	)  {
		translationItems(
			stage: $stage
			first: 1
			where: {
				moduleId: {
					eq: $moduleId
				}
				phraseId: {
					eq: $phraseId
				}
				languageCode: {
					eq: $languageCode
				}
			}
		) {
			nodes {
				id
			}
		}
	}
`;

export const PUT_TRANSLATION_ITEM = gql`
	mutation Mutation(
		$stage: String
		$translation: TranslationItemInput!
	) {
		putTranslationItem(
			stage: $stage
			translation: $translation
		) {
			success
			errors {
				message
				code
			}
		}
	}
`;

export const DELETE_TRANSLATION_ITEMS = gql`
	mutation Mutation(
		$stage: String
		$translationItemIds: [UUID!]!
	) {
		deleteTranslationItems(
			stage: $stage
			translationItemIds: $translationItemIds
		) {
			errors {
				message
				code
			}
		}
	}
`;

export const APPROVE_TRANSLATIONS = gql`
	mutation Mutation(
		$stage: String
		$translationItemIds: [UUID!]!
	) {
		approveTranslations(
			stage: $stage
			translationItemIds: $translationItemIds
		) {
			approvalCount
			approvalDate
			errors {
				message
				code
			}
		}
	}
`;


export const MODULES_INDEX = gql`
	query Query(
		$stage: String
	) {
		modules(
			stage: $stage
			first: 999999
			order: [ { name: ASC } ]
		) {
			nodes {
				id
				name
			}
		}
	}
`;

export const PHRASES_INDEX = gql`
	query Query(
		$stage: String
	) {
		phraseItems(
			stage: $stage
			first: 999999
			order: [ { phrase: ASC } ]
		) {
			nodes {
				id
				phrase
			}
		}
	}
`;
